import { toast } from 'sonner';
import { Mic, MicOff } from 'lucide-react';
import { dictatePressure } from '../lib/agentApp';
import { useVoice, beep } from './MoistVoice';

// say the measured pressure ("4,2") or "Hydrant 3 ist 4,2" – entered at once, offline where possible
export default function PressureVoice({ t }) {
  const { on, toggle } = useVoice(t, (text) => {
    const r = dictatePressure(text);
    if (!r) return;
    if (r.ok) beep(); else toast.error(t.prVoiceNoObj);
  }, null, t.prVoiceHint);
  return <button className={`btn btn-sm btn-outline ${on ? 'rec' : ''}`} data-testid="pressure-voice-btn" onClick={toggle}>{on ? <MicOff size={14} /> : <Mic size={14} />} {on ? t.moVoiceStop : t.prVoice}</button>;
}
